import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Printer } from 'lucide-react';
import { Logo } from '@/components/Logo';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[hsl(222_47%_11%)] text-white" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <Logo size="md" dark />
            <p className="mt-3 text-xs uppercase tracking-[0.08em] text-white/60">Enseigne Intermarché</p>
            <p className="mt-3 text-sm text-white/70 leading-relaxed">
              Grossiste & détaillant à dominante alimentaire en France. Approvisionnement de qualité pour supermarchés et commerces de détail.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm uppercase tracking-[0.08em] text-white/60">Catégories</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/boutique?category=alimentation" className="hover:text-[hsl(186_55%_55%)]">Alimentation</Link></li>
              <li><Link to="/boutique?category=maison-decoration" className="hover:text-[hsl(186_55%_55%)]">Maison & Décoration</Link></li>
              <li><Link to="/boutique?category=multimedia-informatique" className="hover:text-[hsl(186_55%_55%)]">Multimédia & Informatique</Link></li>
              <li><Link to="/boutique?category=vins-spiritueux" className="hover:text-[hsl(186_55%_55%)]">Vins & Spiritueux</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm uppercase tracking-[0.08em] text-white/60">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-white/85">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-[hsl(186_55%_55%)]" />
                <span>92 Allée de la Picholine, Quartier Pérouse Ouest, 30320 Marguerittes, France</span>
              </li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[hsl(186_55%_55%)]" /><a href="tel:0537078109">05 37 07 81 09</a></li>
              <li className="flex items-center gap-2"><Printer className="w-4 h-4 text-[hsl(186_55%_55%)]" />Fax : 05 37 07 99 90</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[hsl(186_55%_55%)]" /><a href="mailto:contact@alofisa.eu" data-testid="footer-contact-email">contact@alofisa.eu</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm uppercase tracking-[0.08em] text-white/60">Horaires</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/85">
              <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-[hsl(186_55%_55%)]" />Lundi – Vendredi : 9h – 17h</li>
              <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-[hsl(186_55%_55%)]" />Samedi & Dimanche : Fermé</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-white/60">
          <div>© {year} ALOFI SA — SAS au capital de 64 000 € · SIREN 383 370 442 · RCS Nîmes · TVA FR89383370442</div>
          <div className="flex items-center gap-4 flex-wrap">
            <Link to="/mentions-legales" className="hover:text-white" data-testid="footer-mentions-legales-link">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-white" data-testid="footer-privacy-link">Confidentialité</Link>
            <Link to="/cgv" className="hover:text-white">CGV</Link>
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Espace admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
